import { AuthenticatedRequest, HTTPMethod, APIVersion, BasicRequest, APIError } from "../requests/request";
import { DeviceData, Device, APIErrorType } from "..";

export class API {

    public static resendVerification(): Promise<void> {
        let apiRequest = new AuthenticatedRequest<void>('/resend-verification', HTTPMethod.POST, APIVersion.v1_0);

        return apiRequest.send().then((response) => {
            return void 0;
        });
    }

    public static verify(code: string): Promise<void> {
        let apiRequest = new AuthenticatedRequest<void>('/verify', HTTPMethod.POST, APIVersion.v1_0, undefined, { code });

        return apiRequest.send().then((response) => {
            return void 0;
        });
    }

    /**
     * Login the user
     * @param {string} email
     * @param {string} password
     * @returns {Promise<User>} The Promise contains either a user or a LoginUserError if rejected
     */
    public static login(email: string, password: string, device: DeviceData): Promise<Device> {
        let apiRequest = new BasicRequest<Device>('/login', HTTPMethod.POST, APIVersion.v1_0, undefined, {
            email: email,
            password: password,
            device: device
        });

        return apiRequest.send(Device).then((response) => {
            return <Device>response.data
        })
    }

    /**
     * Registers a new facebook user with the provided data
     * @param {string} facebook_token
     * @returns {Promise<User>} The Promise contains either a user or a LoginUserError if rejected
     */
    public static authenticateFacebookUser(facebook_token: string, device: DeviceData): Promise<Device> {
        let apiRequest = new BasicRequest<Device>('/login/facebook', HTTPMethod.POST, APIVersion.v1_0, undefined, {
            "facebook_token": facebook_token,
            "device": device
        });

        return apiRequest.send(Device).then((response) => {
            return <Device>response.data
        })
    }

}


// WEBPACK FOOTER //
// ./src/api/endpoints/login.ts